import { useQuery } from '@tanstack/react-query';
import { isListEnabled } from 'utils/queryHelpers';

import { QueryContextFromKeys, QueryParamModel } from 'models';
import { statisticsService } from 'services';

type ReportCodesByWorkerQueryContexts = QueryContextFromKeys<typeof ReportCodesByWorkerKeys>;

export const ReportCodesByWorkerKeys = {
  all: [{ scope: 'reportCodesByWorker' }] as const,
  lists: () => [{ ...ReportCodesByWorkerKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) =>
    [{ ...ReportCodesByWorkerKeys.lists()[0], params }] as const,
};

const fetchReportCodesByWorkerList = async ({
  queryKey: [{ params }],
}: ReportCodesByWorkerQueryContexts['list']) =>
  statisticsService.getReportCodesByWorkerList(params);

const exportReportCodesByWorker = async ({
  queryKey: [{ params }],
}: ReportCodesByWorkerQueryContexts['list']) => statisticsService.exportReportCodesByWorker(params);

export const useReportCodesByWorkerListList = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: ReportCodesByWorkerKeys.list(params),
    queryFn: fetchReportCodesByWorkerList,
    enabled: isListEnabled(params),
  });
};

export const useExportReportCodesByWorker = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: ReportCodesByWorkerKeys.list(params),
    queryFn: exportReportCodesByWorker,
    enabled: false,
  });
};
